import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_3 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_4 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-lp-100 bg-red-lp-50 rounded-md text-sm px-1.5 flex gap-x-1 items-center w-max mt-4",
  style: {"padding-top":"2px","padding-bottom":"2px"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Nomor telah melebihi ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" COD/DFOD per hari. ")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "font-normal text-12px text-black-lp-300 font-montserrat py-1 text-center",
  style: {"width":"322px"}
}, " Nomor handphone baru memiliki batas transaksi COD/DFOD per hari sebesar 10 STT (tidak termasuk CNX) atau total tarif STT melebihi Rp300.000 ", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_14 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_15 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_16 = { class: "w-1/2 mr-4" }
const _hoisted_17 = { class: "p-field-checkbox-grey mt-3 text-gray-lp-600 cursor-not-allowed" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5",
  for: "sender",
  style: {"color":"#9e9e9e"}
}, "Simpan detail pengirim", -1)
const _hoisted_19 = { class: "w-full mt-4" }
const _hoisted_20 = { class: "font-semibold text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectPhoneCountryV2 = _resolveComponent("SelectPhoneCountryV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_SelectCustomerV2 = _resolveComponent("SelectCustomerV2")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_EditCustomerForm = _resolveComponent("EditCustomerForm")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "flex flex-col p-6",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Icons, { name: "icon-detail-sender" }),
          _createVNode(_component_Title, {
            label: "Detail pengirim",
            fontSize: 20
          })
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('bookingShipment.column.shipperPhoneNumber')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectPhoneCountryV2, {
                  column: "Pengirim",
                  error: _ctx.phoneNumberError,
                  phone: _ctx.modelValue.sttSenderPhone,
                  code: _ctx.modelValue.sttSenderPhoneCode,
                  flag: _ctx.manualBooking.sttSenderPhoneFlag,
                  isLoading: _ctx.isLoadingCustomer,
                  options: _ctx.senders,
                  keyName: "customerPhoneNumber",
                  countryCodeButtonId: "button_country_code_sender_booking",
                  phoneNumberFieldId: "field_phone_number_booking",
                  onSetPhone: _ctx.setPhoneSender,
                  onSetPhoneCode: _ctx.setPhoneCodeSender,
                  onSetPhoneFlag: _ctx.setPhoneFlagSender,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneCodeSender,
                  onEditItem: _ctx.editItem,
                  onCheckFocus: _ctx.checkFocus,
                  onSelectItem: _ctx.onChooseSenders,
                  disabled: _ctx.disabledPhone
                }, null, 8, ["error", "phone", "code", "flag", "isLoading", "options", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhoneCode", "onEditItem", "onCheckFocus", "onSelectItem", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.error.senderPhoneLimited || _ctx.errorMessageCodDfodFraudSuspected)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6,
                  (_ctx.error.senderPhoneLimited)
                    ? (_openBlock(), _createBlock("span", _hoisted_7, [
                        _hoisted_8,
                        _createVNode("span", {
                          class: "hover:underline font-semibold cursor-pointer",
                          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltipHeader($event))),
                          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltipHeader($event)))
                        }, " limit transaksi ", 32),
                        _hoisted_9,
                        _createVNode(_component_OverlayPanel, {
                          ref: "opTooltip",
                          appendTo: "body"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }, 512)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.errorMessageCodDfodFraudSuspected)
                    ? (_openBlock(), _createBlock("span", _hoisted_11, " Nomor ini memiliki tingkat retur COD/DFOD yang tinggi. "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.phoneNumberError.message), 1)
            ], 512), [
              [_vShow, 
              _ctx.phoneNumberError.success &&
                _ctx.phoneNumberError.message &&
                _ctx.accountIsNonForeign
            ]
            ])
          ]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.shipperName'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectCustomerV2, {
                column: "Pengirim",
                placeholder: _ctx.$t('bookingShipment.placeholder.shipperName'),
                error: _ctx.error.sender || false,
                customerName: _ctx.modelValue.sttSenderName,
                "onUpdate:customerName": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.sttSenderName = $event)),
                isLoading: _ctx.isLoadingCustomer,
                options: _ctx.senders,
                errorCaption: 
              _ctx.errorMessageNameLocal !== ''
                ? _ctx.errorMessageNameLocal
                : _ctx.errorMessageName
            ,
                keyName: "customerPhoneNumber",
                onChange: _cache[4] || (_cache[4] = 
              (value) => {
                _ctx.validateSenderName(value);
                _ctx.fetchCustomer(value);
              }
            ),
                onFocus: _cache[5] || (_cache[5] = 
              () => {
                _ctx.$emit('setFieldIndex', 3);
                _ctx.validateSenderName(_ctx.modelValue.sttSenderName);
              }
            ),
                onEditItem: _ctx.editItem,
                onSelectItem: _ctx.onChooseSenders,
                disabled: _ctx.isDisableDeliverySender,
                disableBackground: _ctx.isDisableDeliverySender
              }, null, 8, ["placeholder", "error", "customerName", "isLoading", "options", "errorCaption", "onEditItem", "onSelectItem", "disabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.shipperAddress'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                id: "field_address_sender_booking",
                type: "textarea",
                modelValue: _ctx.modelValue.sttSenderAddress,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.sttSenderAddress = $event)),
                error: 
              _ctx.isShipperAndConsigneeAddressIdentical || _ctx.error.addressSender
            ,
                "error-caption": 
              _ctx.errorMessageAddressLocal !== ''
                ? _ctx.errorMessageAddressLocal
                : _ctx.errorMessageAddress
                ? _ctx.$t('bookingShipment.error.senderAddress')
                : this.$t('bookingShipment.error.sameOriginDestination')
            ,
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                placeholder: _ctx.$t('bookingShipment.placeholder.shipperAddress'),
                maxLength: _ctx.maxAddressLength,
                showMaxLength: true,
                textAreaRows: "1",
                onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('setFieldIndex', 7))),
                onChange: _cache[8] || (_cache[8] = 
              (res) => {
                _ctx.validateAddressSender(res);
              }
            ),
                disabled: _ctx.isDisableDeliverySender,
                disableBackground: _ctx.isDisableDeliverySender
              }, null, 8, ["modelValue", "error", "error-caption", "format", "placeholder", "maxLength", "disabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_Checkbox, {
                id: "checkbox_detail_sender_booking",
                modelValue: _ctx.existCustomerSender.existSender,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.existCustomerSender.existSender = $event)),
                binary: true,
                onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSaveCustomer($event))),
                disabled: _ctx.disableSaveSender || _ctx.isDisableDeliverySender
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_18
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          (
            _ctx.getAccount.accountType === 'partner' ||
              _ctx.getAccount.accountType === 'client'
          )
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                class: "flex flex-row p-3 bg-gray-lp-1000",
                isShadow: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icons, {
                    name: "location-gray",
                    class: "text-gray-lp-600 w-5 mr-2"
                  }),
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.origin.name) + " - " + _toDisplayString(_ctx.origin.zipCode), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.getAccount.accountType === 'internal')
            ? (_openBlock(), _createBlock(_component_SelectSearch, {
                key: 1,
                id: "field_district_sender_booking",
                class: "mt-2",
                onFilter: _ctx.fetchOriginCity,
                isLoading: _ctx.isLoadingOriginCity,
                options: _ctx.originCityList,
                keyName: "name",
                keyValue: "id",
                placeholder: _ctx.$t('bookingShipment.placeholder.districtOriginCity'),
                modelValue: _ctx.modelValue.sttOriginAddress,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.modelValue.sttOriginAddress = $event)),
                onChange: _cache[12] || (_cache[12] = 
            () => {
              _ctx.onUpdateEmbargoStatusFail();
            }
          ),
                isShowErrorIndicator: 
            _ctx.errorEmbargo.originCity || _ctx.errorMessageDistrict
          ,
                onFocus: _ctx.onFocusOriginCity,
                errorCaption: 
            _ctx.errorMessageDistrict ? 'Kecamatan, Kota Asal wajib diisi' : ''
          ,
                isShowErrorMessage: true,
                "is-disabled": "",
                disabledBackground: ""
              }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "isShowErrorIndicator", "onFocus", "errorCaption"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.isOpenUpload)
      ? (_openBlock(), _createBlock(_component_EditCustomerForm, {
          key: 0,
          isShown: _ctx.isOpenUpload,
          "onUpdate:isShown": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isOpenUpload = $event)),
          customer: _ctx.selectedCustomer,
          onOnEditSuccess: _ctx.onChooseSenders
        }, null, 8, ["isShown", "customer", "onOnEditSuccess"]))
      : _createCommentVNode("", true)
  ]))
}